if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
  });

  if ($("a.fancybox")) {
    $("a.fancybox").fancybox();
  }

  $(".featured-items__slider").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 700,
    slidesToScroll: 1,
    prevArrow: ".featured-items-btn-back",
    nextArrow: ".featured-items-btn-next",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".slider-only-image__slider").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".services-shortcode__slider").slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: ".slider-services-back",
    nextArrow: ".slider-services-next",
  });

  $(".short-press__slider").slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".slider__slide").slick({
    infinite: true,
    autoplaySpeed: 5000,
    speed: 700,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: ".slider-btn-back",
    nextArrow: ".slider-btn-next",
  });

  $(".pressSlider__slick").slick({
    fade: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    autoplaySpeed: 3000,
  });

  $(".content-line").prependTo(".form-module-wrapper");

  $(".services-shortcode__filter li").click(function () {
    $(".services-shortcode__slider").slick("unslick");
    const thisIndex = $(this).index();
    $(".services-shortcode--filter .services-shortcode__col").hide();
    $(".services-shortcode__col").eq(thisIndex).fadeIn();
    $(".services-shortcode__col")
      .eq(thisIndex)
      .find(".services-shortcode__slider")
      .slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: ".slider-services-back",
        nextArrow: ".slider-services-next",
      });
    $(".services-shortcode__filter li").removeClass("active");
    $(this).addClass("active");
  });

  var data = document.URL;
  if ($(".services-shortcode__col").length > 0) {
    var top_col = $(".services-shortcode__col").offset().top;
    data = data.split("?")[1];
    $.each($(".services-shortcode__filter li"), function (index, value) {
      if ($(value).data("filter") == data) {
        $("html,body")
          .animate({ scrollTop: top_col - 100 }, 1500)
          .delay(1000);
        $(this).click();
      }
    });
  }

  if (data.indexOf("#") != -1) {
    data = data.split("#")[1];
    var top_ele = $("#" + data).offset().top;
    $("html,body")
      .animate({ scrollTop: top_ele - 150 }, 1500)
      .delay(1000);
  }

  // $('.services-shortcode__filter li').click(function(event){
  //     event.preventDefault();
  //     let thishref = $(this).attr('href');
  //     var hashTop = $(thishref).offset().top;
  //     $('html,body').animate({scrollTop:hashTop-150},1500);
  // });

  if ($(".heat-map__map").length > 0) {
    const points_map = document.querySelectorAll(".heat-map__item");
    $(".heat-map__point").click(function () {
      for (let z = 0; z < points_map.length; z++) {
        if (this.dataset.hotel == points_map[z].dataset.hotel) {
          points_map[z].classList.add("active");
          points_map[z].classList.remove("no-active");
        } else {
          points_map[z].classList.remove("active");
          points_map[z].classList.add("no-active");
        }
      }
      $(".heat-map__point").removeClass("active");
      $(this).addClass("active");
    });

    const point_first = document.querySelectorAll(".heat-map__point");
    point_first[0].click();

    const items_map = document.querySelectorAll(".heat-map__point");
    $(".heat-map__list-items ul li").mouseover(function () {
      for (let z = 0; z < items_map.length; z++) {
        if (this.dataset.tag == items_map[z].dataset.tag) {
          items_map[z].classList.add("active2");
        } else {
          items_map[z].classList.remove("active2");
        }
      }
    });
    $(".heat-map__list-items ul li").mouseout(function () {
      for (let z = 0; z < points_map.length; z++) {
        items_map[z].classList.remove("active2");
      }
    });
  }

  let filter_grid = document.querySelector(".grid__filter");
  if (filter_grid) {
    $(".grid__filter ul li").click(function () {
      const thisTag = $(this).attr("data-tag");
      $(".grid--filter .grid__item").hide();
      $(".grid--filter ." + thisTag).fadeIn();
      $(".grid__filter ul li").removeClass("active");
      $(this).addClass("active");
    });

    const filter_tab = document.querySelectorAll(".grid__filter ul li");
    filter_tab[2].click();
  }
})();
